import React, { useEffect } from "react";
import { StudentTopbar } from "../TopBar/TopBar";
import "./Festive.css";
import { FestiveWebMap } from "./Web/FestiveWebMap";
import { StudentMapMenu } from "../Map/MapMenu/MapMenu";
import { FestiveMobMap } from "./Mob/FestiveMobMap";
import { useGetQuests } from "../../../../hooks/student/quest/useGetQuests";
import { useOutletContext } from "react-router-dom";

export const StudentFestiveMap = () => {
  const { userType } = useOutletContext();
  const { quests, error, getQuests } = useGetQuests();
  const isQuestAssigned = (questId) => {
    const quest = quests.find((q) => q.id === questId);
    return quest?.student_assigned && quest?.school_assigned;
  };
  const isAssignedVasant = isQuestAssigned(23);
  const isAssignedShivratri = isQuestAssigned(24);
  const isAssignedDurga = isQuestAssigned(14);
  const isAssignedNavratri = isQuestAssigned(21);
  const isAssignedRakshaBandhan = isQuestAssigned(17);
  const isAssignedDusshera = isQuestAssigned(15);
  const isAssignedOnam = isQuestAssigned(25);
  const isAssignedGaneshChaturthi = isQuestAssigned(22);
  const isAssignedDiwali = isQuestAssigned(26);
  const isAssignedDhanteras = isQuestAssigned(28);
  const isAssignedDevDiwali = isQuestAssigned(19);
  const isAssignedJanamAshtami = isQuestAssigned(29);
  const isAssignedUttarayan = isQuestAssigned(27);
  const isAssignedHoli = isQuestAssigned(13);

  useEffect(() => {
    if (userType === "school-student") {
      getQuests("festive");
    }
  }, []);

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div className="StudentAdminBody QuestFestiveCard InrPageTopBarMargin">
      <div className="container-fluid">
        <div className="fest-dsktp-dnone">
          <FestiveMobMap
            userType={userType}
            isAssignedVasant={isAssignedVasant}
            isAssignedShivratri={isAssignedShivratri}
            isAssignedDurga={isAssignedDurga}
            isAssignedNavratri={isAssignedNavratri}
            isAssignedRakshaBandhan={isAssignedRakshaBandhan}
            isAssignedDusshera={isAssignedDusshera}
            isAssignedOnam={isAssignedOnam}
            isAssignedGaneshChaturthi={isAssignedGaneshChaturthi}
            isAssignedDiwali={isAssignedDiwali}
            isAssignedDhanteras={isAssignedDhanteras}
            isAssignedDevDiwali={isAssignedDevDiwali}
            isAssignedJanamAshtami={isAssignedJanamAshtami}
            isAssignedUttarayan={isAssignedUttarayan}
            isAssignedHoli={isAssignedHoli}
          />
        </div>

        <div className="fest-mob-dnone">
          <FestiveWebMap
            userType={userType}
            isAssignedVasant={isAssignedVasant}
            isAssignedShivratri={isAssignedShivratri}
            isAssignedDurga={isAssignedDurga}
            isAssignedNavratri={isAssignedNavratri}
            isAssignedRakshaBandhan={isAssignedRakshaBandhan}
            isAssignedDusshera={isAssignedDusshera}
            isAssignedOnam={isAssignedOnam}
            isAssignedGaneshChaturthi={isAssignedGaneshChaturthi}
            isAssignedDiwali={isAssignedDiwali}
            isAssignedDhanteras={isAssignedDhanteras}
            isAssignedDevDiwali={isAssignedDevDiwali}
            isAssignedJanamAshtami={isAssignedJanamAshtami}
            isAssignedUttarayan={isAssignedUttarayan}
            isAssignedHoli={isAssignedHoli}
          />
        </div>

        <div>
          <StudentMapMenu />
        </div>
      </div>
    </div>
  );
};
